import React from 'react';
import clsx from 'clsx';
import { AlertTriangle, CheckCircle2 } from 'lucide-react';

const TONES = {
  success: { icon: CheckCircle2, border: 'border-ninja-green', iconClass: 'text-ninja-green' },
  warning: {
    icon: AlertTriangle,
    border: 'border-amber-400 dark:border-amber-600',
    iconClass: 'text-amber-600 dark:text-amber-400',
  },
};

/**
 * How a task ended: a headline and what to know before the next one. It has
 * no buttons of its own: the screen's primary, in `OperatorActionBar`, says
 * where to go next. The tone shows in the icon and the border, never alone.
 *
 * @param {object} props
 * @param {string} props.title - «ORD-60 empacada».
 * @param {'success'|'warning'} [props.tone='success']
 * @param {string} props.testId
 * @param {object} [props.data] - Extra `data-*` attributes.
 * @param {React.ReactNode} [props.children]
 */
export const ResultCard = ({ title, tone = 'success', testId, data = {}, children }) => {
  const { icon: Icon, border, iconClass } = TONES[tone] ?? TONES.success;

  return (
    <section
      data-testid={testId}
      {...data}
      data-tone={tone}
      aria-label={title}
      className={clsx('space-y-3 rounded-3xl border-2 bg-white p-4 dark:bg-[#1a1a1a]', border)}
    >
      <div className="flex items-center gap-3">
        <Icon size={28} aria-hidden="true" className={clsx('shrink-0', iconClass)} />
        <p className="text-lg font-bold text-ninja-dark dark:text-white">{title}</p>
      </div>
      {children}
    </section>
  );
};
